// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3IOGy","col":"styles_col__qsV_A"};